function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 30.9987C24.2843 30.9987 31 24.283 31 15.9987C31 7.71445 24.2843 0.998718 16 0.998718C7.71573 0.998718 1 7.71445 1 15.9987C1 24.283 7.71573 30.9987 16 30.9987Z",
  fill: "#FCE8E9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.1 22C15.8824 22 15.6698 22.0645 15.4889 22.1854C15.308 22.3063 15.167 22.478 15.0837 22.679C15.0005 22.88 14.9787 23.1012 15.0211 23.3146C15.0636 23.528 15.1683 23.724 15.3222 23.8778C15.476 24.0317 15.672 24.1364 15.8854 24.1789C16.0988 24.2213 16.32 24.1995 16.521 24.1163C16.7219 24.033 16.8937 23.892 17.0146 23.7111C17.1355 23.5302 17.2 23.3176 17.2 23.1C17.2 22.8083 17.0841 22.5285 16.8778 22.3222C16.6715 22.1159 16.3917 22 16.1 22Z",
  fill: "#EB636B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16 19V9",
  stroke: "#EB636B",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgToastError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastError);
export default __webpack_public_path__ + "static/media/toast-error.31c6e5df.svg";
export { ForwardRef as ReactComponent };